import axios from "axios";
import authConfig from "src/configs/auth";
import { toast } from "react-hot-toast";
import { PublicRoutes } from "src/utils/constants";

/** Avoid "infinite" loading when the API is down, unreachable, or mismatched (wrong host/port). */
const REQUEST_TIMEOUT_MS = 60_000;

export const axiosInstance = axios.create({
  timeout: REQUEST_TIMEOUT_MS,
  headers: {
    "Content-Type": "application/json",
    authorization: `Bearer ${localStorage.getItem(
      authConfig.storageTokenKeyName
    )}`,
  },
});

axiosInstance.defaults.headers.common["Content-Type"] = "application/json";

axiosInstance.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem(authConfig.storageTokenKeyName);
    if (token) {
      config.headers["authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.localStorage.removeItem(authConfig.storageUserDataKeyName);
      window.localStorage.removeItem(authConfig.storageTokenKeyName);
      if (!PublicRoutes.includes(window.location.pathname)) {
        toast.error("Session expired. Please log in again.");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
// access token ->  8hr
// refresh token -> 90 days
